module.exports = __webpack_public_path__ + "static/stable3-f94761f4030e13b9216ce693bd77d664.jpg";